import is from '@sindresorhus/is';
import type { FunctionComponent, ReactNode } from 'react';
import { useEffect } from 'react';
import { createPortal } from 'react-dom';

import { useTileErrorBoundary, useTileSlot, useTilingEngine } from './TilingEngineContext';

export type TilingEnginePortalProps = {
    readonly children: ReactNode;
    readonly id: string;
    readonly maxWidth?: string;
    readonly minWidth?: string;
    readonly pinRight?: boolean;
    readonly width?: string;
};

export const TilingEnginePortal: FunctionComponent<TilingEnginePortalProps> = ({
    children,
    id,
    maxWidth,
    minWidth,
    pinRight,
    width,
}) => {
    const { registerTile } = useTilingEngine();
    const slot = useTileSlot(id);
    const ErrorBoundary = useTileErrorBoundary();

    useEffect(() => {
        return registerTile({ id, maxWidth, minWidth, pinRight, width });
    }, [id, maxWidth, minWidth, pinRight, registerTile, width]);

    if (is.null(slot)) {
        return null;
    }

    const portalChildren = is.nullOrUndefined(ErrorBoundary) ? (
        children
    ) : (
        <ErrorBoundary tileId={id}>{children}</ErrorBoundary>
    );

    return createPortal(portalChildren, slot);
};
